import classNames from 'classnames';
import parse from 'html-react-parser';

import useNavigationHandler from '../../../hooks/useNavigationHandler/useNavigationHandler';

import { TPublication } from '../../../types/TGetPublicationsResponse';

import placeholderImage from '../../../images/placeholder.jpg';

import commons from '../../../shared/styles/common.module.scss';
import styles from './PublicationItem.module.scss';

type TProps = {
  publicationItem: TPublication;
};

const PublicationItem = ({ publicationItem }: TProps) => {
  const { createNavigationHandler } = useNavigationHandler();

  return (
    <div
      className={classNames(
        styles.publicationItemContainer,
        commons.container,
      )}>
      <div className={styles.publicationItemContent}>
        <a
          key={publicationItem.id}
          href={String(publicationItem.id)}
          onClick={(e) => {
            e.preventDefault();
            createNavigationHandler(
              publicationItem.id,
              'publicationPage',
              ':publicationId',
            );
          }}
          className={styles.publicationItemWrapper}>
          <div className={styles.publicationItemText}>
            <h4 className={styles.publicationItemTitle}>
              {publicationItem.title}
            </h4>
            <p className={styles.publicationItemExcerpt}>
              {parse(publicationItem.excerpt)}
            </p>
          </div>
          <img
            src={publicationItem.featured_image || placeholderImage}
            alt={publicationItem.title}
            className={styles.publicationItemImage}
          />
        </a>
      </div>
    </div>
  );
};

export default PublicationItem;
